import React, { useState } from "react";
import { Link } from "react-router-dom";
import ContactModal from "./ContactModal.tsx";

function MintDBFooter() {
    const [isContactModalOpen, setIsContactModalOpen] = useState(false);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const footerLinkStyle = {
        color: '#64748b',
        textDecoration: 'none',
        fontSize: '0.9rem',
        transition: 'color 0.2s ease',
        display: 'block',
        marginBottom: '0.5rem'
    };

    return (
        <footer style={{
            backgroundColor: '#1A2940',
            marginTop: '0',
            paddingTop: '3rem',
            paddingBottom: '2rem',
            borderTop: '4px solid #60a5fa'
        }}>
            <div className="container">
                <div className="row" style={{ marginBottom: '2rem' }}>
                    {/* About Section */}
                    <div className="col-lg-4 col-md-6 mb-4">
                        <h5 style={{
                            color: '#ffffff',
                            fontWeight: '700',
                            fontSize: '1.2rem',
                            marginBottom: '1rem'
                        }}>
                            MintDB
                        </h5>
                        <p style={{
                            color: '#94a3b8',
                            fontSize: '0.9rem',
                            lineHeight: '1.6',
                            marginBottom: '1rem'
                        }}>
                            A comprehensive neuropsychiatric mutation database integrating genetic variants with protein domains, AlphaMissense predictions, Biobank associations, and population frequency data.
                        </p>
                    </div>

                    {/* Quick Links */}
                    <div className="col-lg-2 col-md-6 mb-4">
                        <h6 style={{
                            color: '#ffffff',
                            fontWeight: '600',
                            fontSize: '1rem',
                            marginBottom: '1rem'
                        }}>
                            Quick Links
                        </h6>
                        <Link
                            to="/"
                            style={footerLinkStyle}
                            onClick={scrollToTop}
                            onMouseEnter={(e) => e.currentTarget.style.color = '#60a5fa'}
                            onMouseLeave={(e) => e.currentTarget.style.color = '#64748b'}
                        >
                            Home
                        </Link>
                        <Link
                            to="/team"
                            style={footerLinkStyle}
                            onClick={scrollToTop}
                            onMouseEnter={(e) => e.currentTarget.style.color = '#60a5fa'}
                            onMouseLeave={(e) => e.currentTarget.style.color = '#64748b'}
                        >
                            Team
                        </Link>
                        <Link
                            to="/faq"
                            style={footerLinkStyle}
                            onClick={scrollToTop}
                            onMouseEnter={(e) => e.currentTarget.style.color = '#60a5fa'}
                            onMouseLeave={(e) => e.currentTarget.style.color = '#64748b'}
                        >
                            FAQ
                        </Link>
                        <a
                            href="#"
                            onClick={(e) => {
                                e.preventDefault();
                                setIsContactModalOpen(true);
                            }}
                            style={{
                                ...footerLinkStyle,
                                cursor: 'pointer'
                            }}
                            onMouseEnter={(e) => e.currentTarget.style.color = '#60a5fa'}
                            onMouseLeave={(e) => e.currentTarget.style.color = '#64748b'}
                        >
                            Contact
                        </a>
                    </div>

                    {/* Resources */}
                    <div className="col-lg-3 col-md-6 mb-4">
                        <h6 style={{
                            color: '#ffffff',
                            fontWeight: '600',
                            fontSize: '1rem',
                            marginBottom: '1rem'
                        }}>
                            Resources
                        </h6>
                        <Link
                            to="/sql-guide"
                            style={footerLinkStyle}
                            onClick={scrollToTop}
                            onMouseEnter={(e) => e.currentTarget.style.color = '#60a5fa'}
                            onMouseLeave={(e) => e.currentTarget.style.color = '#64748b'}
                        >
                            SQL Guide
                        </Link>
                    </div>

                    {/* Affiliation */}
                    <div className="col-lg-3 col-md-6 mb-4">
                        <p style={{
                            color: '#94a3b8',
                            fontSize: '0.9rem',
                            lineHeight: '1.6',
                            marginBottom: '1.5rem'
                        }}>
                            <strong style={{ color: '#ffffff' }}>Flinders University</strong><br />
                            College of Medicine and Public Health<br />
                            South Australia, Australia
                        </p>

                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '1rem',
                            alignItems: 'flex-start'
                        }}>
                            <img
                                src="/flinders-logo.jpg"
                                alt="Flinders University"
                                style={{
                                    width: '150px',
                                    height: '40px',
                                    objectFit: 'cover',
                                    objectPosition: 'left center',
                                    opacity: 0.9,
                                    transition: 'opacity 0.3s ease'
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.opacity = '1'}
                                onMouseLeave={(e) => e.currentTarget.style.opacity = '0.9'}
                            />
                            <img
                                src="/salhn-logo.jpg"
                                alt="Southern Adelaide Local Health Network"
                                style={{
                                    maxWidth: '150px',
                                    width: '100%',
                                    height: 'auto',
                                    opacity: 0.9,
                                    transition: 'opacity 0.3s ease'
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.opacity = '1'}
                                onMouseLeave={(e) => e.currentTarget.style.opacity = '0.9'}
                            />
                        </div>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div style={{
                    borderTop: '1px solid rgba(100, 116, 139, 0.2)',
                    paddingTop: '1.5rem',
                    marginTop: '1rem'
                }}>
                    <div className="row align-items-center">
                        <div className="col-md-6 text-center text-md-start mb-2 mb-md-0">
                            <p style={{
                                color: '#94a3b8',
                                fontSize: '0.85rem',
                                margin: '0'
                            }}>
                                © 2025 MintDB. All rights reserved.
                            </p>
                        </div>
                        <div className="col-md-6 text-center text-md-end">
                            <p style={{
                                color: '#94a3b8',
                                fontSize: '0.85rem',
                                margin: '0'
                            }}>
                                Developed for advancing neuropsychiatric research
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Contact Modal */}
            <ContactModal
                isOpen={isContactModalOpen}
                onClose={() => setIsContactModalOpen(false)}
            />
        </footer>
    );
}

export default MintDBFooter;